export const companyInfo = {
  name: "1stHand Consultancy Ltd",
  slogan: "Protect • Trust • Innovate",
  companyNo: "105 85 263",
  vatNo: "407 84 1202",
  address: "61 Bridge Street, Kington, HR5 3DJ, United Kingdom",
  email: "enquiry@1st-hand.uk",
  website: "https://www.1st-hand.uk"
};

export const networkServices = [
  {
    id: 1,
    title: "Custom Network Design & Solutions",
    description: "Provide tailored network design and solutions that align with your business objectives and operational requirements.",
    icon: "network"
  },
  {
    id: 2,
    title: "Complex Network Project Delivery",
    description: "Deliver complex network projects with precision, ensuring seamless integration and optimal performance.",
    icon: "settings"
  },
  {
    id: 3,
    title: "Network Investigation & Troubleshooting",
    description: "Investigate complex network matters and provide expert troubleshooting to resolve critical network issues.",
    icon: "search"
  },
  {
    id: 4,
    title: "Network Monitoring & Support",
    description: "Monitor your network infrastructure 24/7 and provide ongoing support to ensure business continuity.",
    icon: "activity"
  }
];

export const cybersecurityServices = [
  {
    id: 5,
    title: "Architectural Assessment",
    description: "Comprehensive architectural assessment of your existing environment to identify security gaps and vulnerabilities.",
    icon: "shield"
  },
  {
    id: 6,
    title: "Security Solutions & Controls",
    description: "Assess and recommend how to secure your solutions by implementing the right level of security controls.",
    icon: "lock"
  },
  {
    id: 7,
    title: "Risk Assessments",
    description: "Perform thorough risk assessments to identify potential threats and vulnerabilities in your business environment.",
    icon: "alert-triangle"
  },
  {
    id: 8,
    title: "Security Audits & Risk-Based Decisions",
    description: "Perform comprehensive security audits and help businesses make informed, risk-based decisions.",
    icon: "check-circle"
  }
];

export const aiProjects = [
  {
    id: 1,
    name: "ThreatNet AI",
    description: "Advanced machine learning system for real-time threat detection and automated response mechanisms.",
    status: "Active",
    category: "Threat Detection"
  },
  {
    id: 2,
    name: "SecureFlow",
    description: "AI-powered workflow automation for security incident response and vulnerability management.",
    status: "Research",
    category: "Automation"
  },
  {
    id: 3,
    name: "CyberSentinel",
    description: "Intelligent monitoring system that learns network patterns to identify anomalous behavior.",
    status: "Prototype",
    category: "Network Security"
  },
  {
    id: 4,
    name: "DataGuard Pro",
    description: "AI-enhanced data classification and protection system for sensitive information management.",
    status: "Active",
    category: "Data Protection"
  }
];

export const submitEnquiry = async (formData) => {
  try {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const response = await fetch(`${BACKEND_URL}/api/enquiries`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error('Failed to submit enquiry');
    }

    const result = await response.json();
    return {
      success: true,
      message: 'Thank you for your enquiry. We will contact you shortly.'
    };
  } catch (error) {
    console.error('Error submitting enquiry:', error);
    return {
      success: false,
      message: 'Failed to send enquiry. Please try again later.'
    };
  }
};